'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './digital-signage.routes';

const striptags = require('striptags');

export class DigitalSignageComponent {
  /*@ngInject*/
  constructor(NewsService, ngProgressFactory, $interval) {
    this.NewsService = NewsService;

    this.$interval = $interval;

    this.count = 0;
    this.maxCount = 20;

    this.progressbar = ngProgressFactory.createInstance();
    this.progressbar.setColor('#000');
    this.progressbar.setHeight('3px');

    NewsService.getDigitalSignageFeatured(data => {
      let _cnt = 0;
      this.data = data.map(news => {
        _cnt++;

        let oMappedNews = {
          title: news.title + "<h3 class='pull-right'>"+_cnt+"/"+data.length+"</h3>",
          body: this.remove_tags(news.body),
          user: news.meta.creationUser,
          date: news.meta.creationDate
        };

        if (news.attachments && news.attachments.length) {
          oMappedNews.image = '/api/storage/public/' + news.attachments[0]
        }

        return oMappedNews;
      });

      this.progressbar.setParent(document.getElementById('progressparent'));
      this.progressbar.set(0);

      this.$interval(_ => {

        this.count++;

        this.progressbar.set(this.count / this.maxCount * 100);

        if (this.count == this.maxCount) {
          this.count = 0;
        }

      }, 1000);

    })
  }

  remove_tags(html) {
     return striptags(html, ['br','p','ul','ol','li','b', 'i','u', 'font', 'span'])
  }
}

export default angular.module('conduuApp.digitalSignage', [uiRouter])
  .config(routes)
  .component('digitalSignage', {
    template: require('./digital-signage.html'),
    controller: DigitalSignageComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/digital-signage/digital-signage.component.js